import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timeZone from 'dayjs/plugin/timezone'
import { TIME_ZONE_SGT } from './appConstant';
import { DATE_TIME_FORMAT_SIMPLE } from './appConstant';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timeZone);

export const filterColumnCustomize = (tableData, keyField) => {
    var result = []
    if (tableData) {
        const dataGrouped = Object.groupBy(tableData, e => e[keyField]);
        for (var i in dataGrouped)
            result.push({ text: `${i} (${dataGrouped[i].length})`, value: i })
    }
    return result;
}

export const filterOptionCustomize = (input, option) => {
    var result = getValueWithDefault(option?.children, '').toLowerCase().includes(input.toLowerCase())
    return result;
}

const getValueWithDefault = (value, defaultValue) => {
    var result = value !== null && value !== void 0 ? value : defaultValue;
    return result;
}

export const checkPermissionInlist = (permissionlist, id) => {
    if (permissionlist)
        return permissionlist.includes(id);
    else
        return false;
}

export const checkRolesInlist = (userRoles, requiredRoles) => {
    if (userRoles)
        return requiredRoles.every(role => userRoles.includes(role));
    else
        return false;
}


export const appendQueryParamsToUrl = (url, paramsObj) => {
    if (undefined == paramsObj) {
        return url;
    }
    var urlObj;
    const isUsingLocalBaseUrl = URL.canParse(url);
    if (isUsingLocalBaseUrl) {
        urlObj = new URL(url);
    } else {
        urlObj = new URL(process.env.REACT_APP_API_URL + url);
    }

    const searchParams = new URLSearchParams(urlObj.search);
    for (const [key, value] of Object.entries(paramsObj)) {
        if (value === undefined || value === null || "" === value) continue;
        if (Array.isArray(value)) {
            value.forEach(v => searchParams.append(key, v));
        } else {
            searchParams.set(key, value);
        }
    }
    urlObj.search = searchParams.toString();
    return isUsingLocalBaseUrl ? urlObj.toString() : urlObj.toString().replace(process.env.REACT_APP_API_URL, '');
}


export const reformatDateTime = (inputDateTimeStr, inputFormat, outputFormat) => {
    try {
        const parsed = dayjs(inputDateTimeStr, inputFormat);
        if (undefined === parsed) throw new Error("Invalid datetime");
        return parsed.format(outputFormat);
    } catch (error) {
        console.error("Datetime conversion failed: ", error);
        return null;
    }
}

/**
 * @param {*} inputDateTimeStr ISO format utc time
 * @return SGT time with simpledatetime format
 */
export const convertTimeZone = (inputDateTimeStr) => {
    return dayjs.utc(inputDateTimeStr).tz(TIME_ZONE_SGT).format(DATE_TIME_FORMAT_SIMPLE);
}


export const getCurrentDatetime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so add 1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
  
    return `${year}${month}${day}_${hours}${minutes}${seconds}`;
}
  